import React from "react";
import cx from "classnames";
import Icon from "components/icon/icon";
import { Theme, mapThemeToClassNames } from "ui/themes";

type AmpSidebarProps = {
  theme: Theme;
  mobileMenu?: React.ReactNode;
  action?: React.ReactNode;
};

export function AmpSidebar(props: AmpSidebarProps) {
  const { theme, mobileMenu, action } = props;

  const className = cx({
    sidebar: true,
    [mapThemeToClassNames[theme]]: true,
  });

  return (
    <amp-sidebar
      className={className}
      id="sidebar"
      layout="nodisplay"
      side="right"
    >
      <div className="sidebar__header">
        {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'on' does not exist on type 'DetailedHTML... Remove this comment to see the full error message */}
        <button className="button button--circle" on="tap:sidebar.toggle">
          <span className="button__content">
            <span className="button__icon">
              <Icon size="md" name={Icon.Name.Close} />
            </span>
          </span>
        </button>
      </div>

      <div className="sidebar__content">{mobileMenu}</div>

      <div className="sidebar__action">{action}</div>
    </amp-sidebar>
  );
}

AmpSidebar.Theme = Theme;

export default AmpSidebar;
